import { CompanyFinancialMetricsTable } from 'modules';



export const FC = () => {
  return (
    <CompanyFinancialMetricsTable.FC />
  );
};
